import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import {
  EmailContent,
  FlowChartEmailContentBlock,
} from 'common/builder/components/chart/FlowChart/types/FlowChartEmailContent'

export const getEmailNodeContentBlock = ({
  rootBlockId,
  sender,
  subject,
  preheader,
  content,
}: {
  rootBlockId: string | null
  sender: string
  subject: string
  preheader: string
  content: EmailContent[]
}): FlowChartEmailContentBlock => {
  return {
    id: rootBlockId || 'email_content_block',
    type: FlowChartBlockType.EMAIL_CONTENT,
    data: {
      sender,
      subject,
      preheader,
      content,
    },
  }
}
